import { makeVar, ReactiveVar } from '@apollo/client';
import { produce } from 'immer';
import { EditorState, RawDraftContentState } from 'draft-js';
import { PlanCalculationStatus, PlanFragment, PlanState } from '@/graphql/generated/graphql';

export interface ICurrentPlan {
  data: PlanFragment;
  metadata: IPlanMetadata;
}

export interface IPlanMetadata {
  editorState: EditorState;
  htmlDescriptionContent: string;
  rawDraftContentState?: RawDraftContentState;
  fixedBudget: boolean;
  isEditing: boolean;
}

export const currentPlanInitialState: ICurrentPlan = {
  data: {
    id: '',
    name: '',
    startDate: null,
    endDate: null,
    timezone: null,
    requiresUserAcceptance: false,
    currentState: PlanState.Draft,
    currency: { id: '', code: 'USD', label: 'USA Dollar', popular: 'true', symbol: '$', exchangeRate: 1 },
    description: null,
    isTemplate: false,
    visible: false,
    archived: false,
    firstPublish: true,
    planLength: null,
    budget: null,
    createdAt: null,
    simulation: null,
    testCalculationStatus: PlanCalculationStatus.Idle,
    updatedAt: null,
  },
  metadata: {
    editorState: EditorState.createEmpty(),
    htmlDescriptionContent: '',
    fixedBudget: false,
    isEditing: true,
  },
};

export const currentPlanVar: ReactiveVar<ICurrentPlan> = makeVar<ICurrentPlan>(currentPlanInitialState);

export const setPlanData = (payload: Partial<PlanFragment>) => {
  currentPlanVar(
    produce(currentPlanVar(), (draft) => {
      draft.data = {
        ...draft.data,
        ...payload,
      };
    })
  );
};

export const setPlanMetadata = (payload: Partial<IPlanMetadata>) => {
  currentPlanVar(
    produce(currentPlanVar(), (draft) => {
      draft.metadata = {
        ...draft.metadata,
        ...payload,
      };
    })
  );
};
